import React, {Component} from "react";
import PropTypes from 'prop-types';

import {FormManagerContext} from "../Form/FormManagerContext";
import XTextArea from "../Layout/XTextArea";

class   TextArea extends Component{

    constructor(props) {
        super(props);
        this.input=React.createRef()
        this.props=props;
    }

    setValue(val){
        this.input.current.value=val;
    }

    render() {
        const {
            className,placeholder,
            id,
            onChange,onKeyPress,
            value,rows
        } = this.props;

        let fmState = this.context;

        return (
            <React.Fragment>
                <XTextArea  type="text" placeholder={placeholder}  eleRef={this.input}  id={id}  className={`form-control ${className}`}
                         value={value}  readonly={fmState.isReadOnly} rows={rows} onKeyPress={onKeyPress}
                         onChange={onChange}     />
            </React.Fragment>
        )
    }
}

TextArea.propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    rows: PropTypes.number,
};

TextArea.defaultProps = {
    className:"",
    placeholder:"",
};

TextArea.contextType = FormManagerContext;

export default TextArea;
